import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts';
import { fetchRackStorage } from '../../resources/DashboardResource';
import React, { useEffect, useState } from "react";

export default function RackStorage() {
  const [dataRackStorage, setDataRackStorage] = useState(null);

  const chartSetting = {
    width: 650,
    height: 300,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: 'translate(-20px, 0)',
      },
    },
  };

  const valueFormatter = (value) => `${value}`;

  const fetchDataRackStorage = () => {
    fetchRackStorage()
      .then((res) => {
        setDataRackStorage(res.data);
      })
      .catch((err) => {
        setDataRackStorage([]);
      });
  };

  useEffect(() => {
    fetchDataRackStorage();
  }, []);

  return (
    <div>
      {!dataRackStorage ? <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '260px'
      }}>
        <div className="spinner-border text-primary" role="status"> <span className="visually-hidden">Loading...</span>
        </div>
      </div> : dataRackStorage.length === 0 ? <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '260px'
      }}>
        <div><span>Data is Empty</span></div>
      </div> : <BarChart
        dataset={dataRackStorage}
        xAxis={[{ scaleType: 'band', dataKey: 'month' }]}
        series={[
          { dataKey: 'inbound', label: 'Inbound', valueFormatter },
          { dataKey: 'request', label: 'Request', valueFormatter },
          { dataKey: 'outbound', label: 'Outbound', valueFormatter },
        ]}
        {...chartSetting}
        colors={['#962DFF', '#4A3AFF', '#FBCDFF']}
      />}
    </div>
  );
}